/* Imports */
import SmoothScroll from '@garmin/smooth-scroll';

export default (to) => {
  if (to.hash) {
    return SmoothScroll(`[id='${to.hash.split('#')[1]}']`);
  }

  return new Promise((resolve) => {
    const scrollTo = to.matched.find((m) => m.meta?.scrollTo)?.meta.scrollTo;

    if (scrollTo) {
      setTimeout(() => {
        SmoothScroll(scrollTo, 'top');
      }, 500);
    }

    resolve();
  });
};
